import { Card } from 'react-bootstrap';
import PropTypes from 'prop-types';

const Service = ({ startTime, endTime, fromRouteName, toRouteName, label }) => (
  <div className="service">
    <Card className="border-0">
      <Card.Body className="p-0">
        <div className="service__data-top">
          <div className="service__stop-info">
            <div className="service__icon">
              <i className="fas fa-circle service__ellipse" />
              <div className="service__line" />
              <i className="far fa-circle service__ellipse" />
            </div>
            <div>
              <div>
                <div className="service__time">{startTime}</div>
                <div className="service__stop">{fromRouteName}</div>
              </div>
              <div>
                <div className="service__time">{endTime}</div>
                <div className="service__stop">{toRouteName}</div>
              </div>
            </div>
          </div>
          <div className="service__label">
            <span className="ps-1 text-x-small">{label}</span>
          </div>
        </div>
      </Card.Body>
    </Card>
  </div>
);

Service.propTypes = {
  startTime: PropTypes.string.isRequired,
  endTime: PropTypes.string.isRequired,
  fromRouteName: PropTypes.string.isRequired,
  toRouteName: PropTypes.string.isRequired,
  label: PropTypes.string,
};

export default Service;
